// Packages
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';
import qs from 'querystring';
import CircularProgress from '@mui/material/CircularProgress';

// Relatives
import Layout from '../../layouts/Layout/Layout';
import EventsFilter from './components/EventsFilter';
import EventsList from './components/EventsList';
import AppContext from '../../contexts/AppContext';
import http from '../../services/api/http';
import UserContext from '../../contexts/UserContext';

const EventsIndex = () => {
  const [Eventss, setCampaings] = useState([]);
  const [artistId, setArtistId] = useState('');
  const [EventsStatus, setEventsStatus] = useState(1);
  const { apiHost } = useContext(AppContext);
  const { token, userNGOSelected } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [pageOffset, setPageOffset] = useState(1);
  const [urlParams, setUrlParams] = useSearchParams();
  const [disableScroll, setDisableScroll] = useState(false);

  const mapEvents = EventsRaw => {
    const { id, name, formatted_address: formattedAddress, goal_completion_percentage: goalProgress } = EventsRaw;
    const fromDate = get(EventsRaw, '_related.event_dates.0.start_date');
    const toDate = get(EventsRaw, '_related.event_dates.0.end_date');
    const eventPerformances = get(EventsRaw, '_related.event_performances');
    const avatarImage = get(EventsRaw, '_misc.avatar.large_image');
    const bgImage = get(EventsRaw, '_misc.banner.large_image');

    return {
      id,
      name,
      address: formattedAddress,
      goalProgress,
      participants: eventPerformances.map(participant => {
        const {
          _related: { artist, band }
        } = participant;

        if (artist) {
          const { handle } = artist;
          const largeImage = get(artist, '_misc.avatar.large_image');

          return {
            avatarImage: largeImage || null,
            name: handle
          };
        }

        if (band) {
          const { handle } = band;
          const largeImage = get(band, '_misc.avatar.large_image');

          return {
            avatarImage: largeImage || null,
            name: handle
          };
        }

        return {
          avatarImage: null,
          name: null
        };
      }),
      fromDate: fromDate * 1000,
      toDate: toDate * 1000,
      bgImage: bgImage || null,
      avatarImage: avatarImage || null
    };
  };

  const performSearch = async (page = 1, pageSize = 10, append = false) => {
    const params = urlParams.toString();
    setLoading(true);

    const response = await http(apiHost, token.accessToken, token.tokenType)
      .get(
        `/api/web/v2/events?page=${page}&page_size=${pageSize}&event_type=event&venue_id=${userNGOSelected.id}&status=${EventsStatus}&${params === '' ? '' : `&${params}`}`
      )
      .catch(() => {});

    setLoading(false);
    const { success, error, output } = get(response, 'data', {});
    if (!success) {
      console.warn(error);

      return;
    }

    if(output.data.length > 0){
      if (append) {
        setCampaings(state => [...state, ...output.data.map(EventsRaw => mapEvents(EventsRaw))]);
      } else {
        setCampaings(output.data.length > 0 ? output.data.map(EventsRaw => mapEvents(EventsRaw)) : []);
      }

      if (output.data.length < pageSize && !disableScroll) {
        setDisableScroll(true);
      } else if (output.data.length >= pageSize && disableScroll) {
        setDisableScroll(false);
      }
    }else{
      setCampaings([]);
    }

  };

  useEffect(() => {
    if (userNGOSelected) {
      performSearch();
    }
  }, [urlParams, EventsStatus, userNGOSelected, artistId]);

  const handleClickStatus = status => () => setEventsStatus(status);

  const handleClickSearch = params => {
    setUrlParams(params);
  };

  const handleLoadMore = async () => {
    performSearch(pageOffset + 1, 10, true);
    setPageOffset(state => state + 1);
  };

  const filterValues = useMemo(() => qs.parse(urlParams.toString()), [urlParams]);

  return (
    <Layout title="Eventss" breadcrumb={['Home', 'Events']}>
      <div className="Events-index d-flex align-items-start">
        <div className="col-12 col-sm-4">
          <Link to="/Events/create" className="Events-create-btn btn btn-light d-block mx-auto">
            CREATE
          </Link>
          <EventsFilter value={filterValues} onSearch={handleClickSearch} disabled={loading} artistUserData={data => {
            setArtistId(data.id);
          }} />
        </div>
        <div className="d-flex flex-column col-12 col-sm-8">
          <div className="Events-status">
            <div
              className={classNames('Events-status__item', { active: EventsStatus === 1 })}
              onClick={handleClickStatus(1)}
            >
              ACTIVE
            </div>
            <div
              className={classNames('Events-status__item', { active: EventsStatus === 4 })}
              onClick={handleClickStatus(4)}
            >
              DRAFT
            </div>
            <div
              className={classNames('Events-status__item', { active: EventsStatus === 3 })}
              onClick={handleClickStatus(3)}
            >
              TRASH
            </div>
          </div>
          {!loading && (
            <EventsList
              canAutoScroll={!disableScroll}
              containerNode={document}
              onCallback={handleLoadMore}
              className="flex-grow-1"
              items={Eventss}
              loading={loading}
            />
          )}
          {loading && (
          <div className='fundraiser-list'>
            <div className="list-empty">
              <CircularProgress />
            </div>
          </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default EventsIndex;
